/**
 * クエリーパラメーター取得メソッド
 */
const getParam = (key, url) => {
  if (!url) url = window.location.href;
  key = key.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + key + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

/**
 * ハッシュ取得
 */
const getHash = () => {
  let hash = location.hash.split("?")[0];
  if (hash) {
    console.log("hashを消す");
    let url = location.pathname + location.href.split(hash)[1];
    history.replaceState("", document.title, url);
  }

  return hash;
};

/**
 * ディレクトリ取得
 */
const getDirectory = () => {
  const pathname = location.pathname;
  return pathname.substring(0, pathname.lastIndexOf("/")) + "/";
};

const LocationUtil = {
  getParam: getParam,
  getHash: getHash,
  getDirectory: getDirectory,
};

export default LocationUtil;
